/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_ConfirmInputs */

const en_pwf_confirm = /** @type {(inputs: Pwf_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch workflow`)
};

const de_pwf_confirm = /** @type {(inputs: Pwf_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow wechseln`)
};

/**
* | output |
* | --- |
* | "Switch workflow" |
*
* @param {Pwf_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_confirm = /** @type {((inputs?: Pwf_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_confirm(inputs)
	return en_pwf_confirm(inputs)
});